import * as React from 'react';

import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';

import { HairAnalyzerConfig } from '../model';

export const useHairAnalyzerBrandData = (): HairAnalyzerConfig => {
  const { product } = useProductDetailContext(false);

  const hairAnalyzer = product.features.hairAnalyzer;
  const brandName = product.brand?.name ?? '';

  // Memoized on purpose: the returned object is an effect dependency of
  // useInitHairAnalyzer, and a fresh literal on every render would re-run
  // Revieve.Init on each re-render.
  return React.useMemo(
    () => ({
      ...(hairAnalyzer as NonNullable<typeof hairAnalyzer>),
      brandName,
    }),
    [hairAnalyzer, brandName]
  );
};
